import { apiClient } from "../config/api.config";

export interface CareType {
  id?: number;
  code: string;
  label: string | null;
}

export function getCareTypes(lang: string) {
  return apiClient.request({
    method: "get",
    url: `/care-types`,
    params: { lang },
  });
}

export function getCareTypeById(id: number) {
  return apiClient.request({
    method: "get",
    url: `/care-types/${id}`,
  });
}

export function getCareTypeByCode(code: string) {
  return apiClient.request({
    method: "get",
    url: `/care-types/code/${code}`,
  });
}

export function createCareTypes(careTypes: CareType[]) {
  return apiClient.request({
    method: "post",
    url: `/care-types`,
    data: careTypes,
  });
}

export function updateCareType(id: number, careType: CareType) {
  return apiClient.request({
    method: "put",
    url: `/care-types/${id}`,
    data: careType,
  });
}

export function deleteCareType(id: number) {
  return apiClient.request({
    method: "delete",
    url: `/care-types/${id}`,
  });
}

